export const getQueryKeys = {
  transports: (companyId) => ['transports', companyId],
  permits: (params) => ['permits', ...Object.values(params)],
};
